// extracted by mini-css-extract-plugin
export default {"container":"YidunCaptcha_container__K87d7"};